// extracted by mini-css-extract-plugin
export var searchHeader = "_y-0";
export var searchHeaderDark = "_y-1";